'use strict';

angular.module('amexReconciliationApp')
  .directive('transactionList', function () {
    return {
      scope: {},
      bindToController: true,
      templateUrl: 'scripts/views/directives/transaction-list.html',
      controllerAs: 'transactionListController',
      controller: function TransactionListController($scope,
                                                     $element,
                                                     $state,
                                                     $translate,
                                                     TransactionsModel,
                                                     TransactionPaginationService,
                                                     SelectedTransactionService,
                                                     SiteConfigModel,
                                                     TransactionSortModel,
                                                     TransactionFilterModel,
                                                     TransactionSearchModel,
                                                     TransactionTabFilterModel,
                                                     $uibModal,
                                                     actionStatusMappings,
                                                     SiteConfigRepository,
                                                     $analytics) {

        var self = this;
        self.loading = false;
        self.isBcaManager = TransactionSearchModel.isBcaManager;
        self.isBtaProductType = SiteConfigModel.isBtaProductType;
        self.siteConfigModel = SiteConfigModel;
        self.transactionCount = TransactionsModel.transactionCount;

        self.pageSize = TransactionPaginationService.pageSize;
        self.pageStart = TransactionPaginationService.pageStart;
        self.pageEnd = TransactionPaginationService.pageEnd;
        self.totalCount = TransactionPaginationService.totalCount;
        self.currentPage = TransactionPaginationService.pageNumber;
        self.updateCurrentPage = TransactionPaginationService.updateCurrentPage;
        self.transactions = TransactionPaginationService.recordsOnCurrentPage;

        self.displayBta = SiteConfigModel.isBta;
        self.displayPo = SiteConfigModel.isPo;
        self.displayPreAuthData = SiteConfigModel.isPreAuth;
        self.approvalSettingOnForRole = SiteConfigModel.approvalSettingOnForRole;
        self.approvalSettingOnForSite = SiteConfigModel.approvalSettingOnForSite;

        self.isChecked = SelectedTransactionService.isSelected;
        self.displayCustomizableColumn = SiteConfigModel.displayCustomizableColumn;

        SiteConfigRepository.findSiteConfig(TransactionSearchModel.siteNumber()).then(function (siteConfig) {
          SiteConfigModel.siteConfig(siteConfig);
          self.selectedHeaderColumnsArray = self.siteConfigModel.selectedHeaderColumns(self.siteConfigModel.getAvailableColumns(),TransactionSearchModel.siteNumber());
          self.transListDivWidth = 1050;
          self.tableWidth  = function ( ) {
            var tabWidth;
            var selectedColoumWidth = 0;
            for(var i=0;i<self.selectedHeaderColumnsArray.length;i++){
              if(undefined ===  self.selectedHeaderColumnsArray[i].widthValue) {
                selectedColoumWidth = selectedColoumWidth + 120;
              } else {
                selectedColoumWidth = selectedColoumWidth + self.selectedHeaderColumnsArray[i].widthValue;
              }
            }
            if(selectedColoumWidth < self.transListDivWidth) {
              tabWidth = self.transListDivWidth + 90;
            } else {
              tabWidth = selectedColoumWidth + 50;
            }
            if(isNaN(tabWidth)) {
              tabWidth = 1200;
            }
            return tabWidth;
          };
        });


        self.isFieldSelected = function isFieldColumnSelected(fieldName) { return SiteConfigModel.isColoumnSelected(fieldName);};

        self.getTransactionSortableColumnHeader = function (columnHeader) {
          if(columnHeader.type === 'ACF') {
            return 'ACF'+ columnHeader.value;
          } else {
            return columnHeader.displayValue.toLowerCase();
          }
        };

        SiteConfigModel.onSiteConfigChanged($scope, function () {
          TransactionFilterModel.fields(getDisplayedColumnList());
        });

        function onLoadingStateChanged(newLoadingState) {
          self.loading = newLoadingState;
        }

        TransactionsModel.onLoadingChanged($scope, onLoadingStateChanged);

        self.selectTransaction = function (transaction, pageIndex, event) {
          if(cancelRouting(event)) {
            return;
          }

          $state.go('transactions.overview.allocations', {
            transactionId: transaction.id,
            index: self.getTransactionIndex(pageIndex)
          });
        };

        self.toggleCheckAllTransactions = function toggleCheckAllTransactions() {
          if (self.allUncheckedOnCurrentPage()) {
            SelectedTransactionService.addTransactions(self.transactions());
          } else {
            SelectedTransactionService.removeAll();
          }
        };

        self.allCheckedOnCurrentPage = function allCheckedOnCurrentPage() {
          return _.every(self.transactions(), self.isChecked);
        };

        self.columnLength = function() {
          return $element.find('.transactions th').length;
        };

        self.allUncheckedOnCurrentPage = function allUncheckedOnCurrentPage() {
          return !_.some(self.transactions(), self.isChecked);
        };

        self.someCheckedOnCurrentPage = function someCheckedOnCurrentPage() {
          return !(self.allCheckedOnCurrentPage() || self.allUncheckedOnCurrentPage());
        };

        self.transactionActionButtonDisabled = function transactionActionButtonDisabled() {
          return _.isEmpty(SelectedTransactionService.selectedTransactions()) || !_.every(SelectedTransactionService.selectedTransactions(), ['lockStatus', 'UNLOCKED']);
        };

        self.displayCurrency = function () {
          var transaction = _.head(self.transactions());
          return _.get(transaction, 'details.billedCurrency');
        };

        self.displayDifferentCurrency = function() {
          var transactions = self.transactions();
          var transaction = _.head(self.transactions());

          for(var i=1; i< transactions.length; i++){
            if(transaction.details.billedCurrency !== transactions[i].details.billedCurrency){
              return true;
            }
          }
          return false;
        };

        self.differentCurrency = function() {
          var diffCurrency =  _.head(_.filter(TransactionsModel.transactions(), function(transaction) {
            return transaction.details.billedCurrency !== 'USD';
          }));
          if(diffCurrency !== undefined){
            return diffCurrency.details.billedCurrency;
          }
        };

        self.showPagination = function() {
          return self.totalCount() > self.pageSize();
        };

        self.getTransactionIndex = function(pageIndex) {
          return pageIndex + TransactionPaginationService.pageStart();
        };

        self.isFilterSearchEmpty = function(){
          return TransactionFilterModel.isFilterEnabled() && self.isTabEmpty();
        };

        self.isTabEmpty = function() {
          return TransactionFilterModel.transactions() !== undefined
            && TransactionFilterModel.transactions().length===0;
        };
        
        self.emptyTabMessage = function () {
          var tabName;

          switch(TransactionTabFilterModel.activeTab()) {
            case 'needs-receipt':
              tabName = 'NeedsReceipts'; break;
            case 'not-reviewed':
              tabName = 'NotReviewed'; break;
            case 'needs-submission':
              tabName = 'NeedsSubmission'; break;
            case 'needs-card-manager-approval':
              tabName = 'NeedsApproval'; break;
            case 'needs-bca-manager-approval':
              tabName = 'NeedsApproval'; break;
            case 'needs-accounting-manager-approval':
              tabName = 'NeedsApproval'; break;
            case 'unlinked':
              tabName = 'Unlinked'; break;
            case 'not-extracted':
              tabName = 'NotExtracted'; break;
            case 'search-results':
              tabName = 'SearchResults'; break;
            default:
              tabName = 'AllTransactions';
          }

          return 'transactions.emptyTabMessage.' + tabName;
        };

        self.displayTransactionRows = function() {
          var onSearchTab = TransactionTabFilterModel.activeTab() === 'search-results';
          var manyTransactions = TransactionsModel.transactionCount() > TransactionsModel.maxTransactions();
          var notLoading = !self.loading;
          var notFilterSearchEmpty = !self.isFilterSearchEmpty();

          if (manyTransactions) {
            if (onSearchTab) {
              return true;
            } else {
              return false;
            }
          } else {
            return notLoading && notFilterSearchEmpty;
          }
        };
        
        self.displayManyTransactionsMessage = function() {
          var notOnSearchTab = TransactionTabFilterModel.activeTab() !== 'search-results';
          var manyTransactions = TransactionsModel.transactionCount() > TransactionsModel.maxTransactions();
          var notLoading = !self.loading;

          return manyTransactions && notLoading && notOnSearchTab;
        };

        self.displayEmptyTransactionListMessage = function() {
          var notDisplayManyTransactionsMessage = !self.displayManyTransactionsMessage();
          var filterSearchEmptyOrTabEmpty = self.isFilterSearchEmpty() || self.isTabEmpty();
          var notLoading = !self.loading;

          return filterSearchEmptyOrTabEmpty && notDisplayManyTransactionsMessage && notLoading;
        };

        self.manyTransactionsMessage = function() {
          var parameters = {
            number: TransactionsModel.transactionCount(),
            limit: TransactionsModel.maxTransactions()
          };

          return $translate.instant('transactions.emptyTabMessage.TooManyTransactions', parameters);
        };

        self.showReceiptIcon = function() {
          return SiteConfigModel.transactionReceiptsEnabled();
        };

        self.sortByReceipt = function() {
          TransactionSortModel.setSortField('receiptsPresent');
        };

        self.showLinkIcon = function() {
          return SiteConfigModel.isBta() || SiteConfigModel.isPo() || SiteConfigModel.isMeetings360();
        };

        self.sortByLinked = function() {
          TransactionSortModel.setSortField('transactionThirdPartyData');
        };

        self.openAdvancedSearchModal = function () {
          $uibModal.open({
            template: '<advanced-search-modal close-modal-callback="$close()"></advanced-search-modal>',
            size: 'xlg'
          });
        };

        self.openColumnSettingsModal = function () {
          $uibModal.open({
            template: '<column-settings-modal close-modal-callback="$close()"></column-settings-modal>',
            size: 'xlg',
            resolve: {
              items: function () {
                return self.selectedHeaderColumnsArray;
              }
            }
          }).result.then(function () {
            self.selectedHeaderColumnsArray = SiteConfigModel.selectedHeaderColumns(SiteConfigModel.getAvailableColumns(),TransactionSearchModel.siteNumber());
        });
        };

        self.isApproved = function(transaction) {
          return _.get(transaction, 'mutableTransactionProperties.' + actionStatusMappings[TransactionSearchModel.roleName()]);
        };

        function cancelRouting(event) {
          var exemptClasses = ['line-item-details-icon', 'receipt-action', 'third-party-data-icon'];
          var classList = event.target.classList;
          return _.intersection(classList, exemptClasses).length > 0;
        }

        function getDisplayedColumnList() {
          self.selectedHeaderColumnsArray = self.siteConfigModel.selectedHeaderColumns(self.siteConfigModel.getAvailableColumns(),TransactionSearchModel.siteNumber());

          var columnList = [];
          for (var i = 0; i < self.selectedHeaderColumnsArray.length; i++) {
            if (self.selectedHeaderColumnsArray[i].type === 'ACF') {
              columnList.push( self.selectedHeaderColumnsArray[i].value );
            } else {
              columnList.push( self.selectedHeaderColumnsArray[i].displayValue );
            }
          }
          return columnList;
        }

        self.sortIconFields =  function (sortColumnName){
          if ('Lock Status (Icon)'.toLowerCase() === sortColumnName.toLowerCase()) {
            TransactionSortModel.setSortField('lockStatus');
          }

          if ( 'Status (Icon)'.toLowerCase() === sortColumnName.toLowerCase()) {
            TransactionSortModel.setSortField('mutableTransactionProperties.transactionStatus');
          }

          if ( 'Exception (Icon)'.toLowerCase() === sortColumnName.toLowerCase()) {
            TransactionSortModel.setSortField('details.exceptionFlag');
          }

          if('LID (Icon)'.toLowerCase() === sortColumnName.toLowerCase()) {
            TransactionSortModel.setSortField('lineItemDetails.hasLineItems');
          }

          if('Comment (Icon)'.toLowerCase() === sortColumnName.toLowerCase()) {
            TransactionSortModel.setSortField('mutableTransactionProperties.commentIndicator');
          }

        };

      }
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/transactionList.js
// module id = 537
// module chunks = 0